const closeAlertMessage = () =>
  $('.notification__icon').on('click', function () { $(this).parent().remove(); });

export default closeAlertMessage;



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/app/assets/javascripts/packs/components/alert-message.js